<template>
    <div v-if="!hideDessConfiguration" class="vrm-dashboard__block dynamic-ess-promotion">
        <div class="vrm-dashboard__block__title dynamic-ess-promotion__title">
            <div>
                <span>{{ $t('dynamicess.promotion.title') }}</span>
                <span class="dynamic-ess-promotion__no-data">
                    - {{ $t('dynamicess.promotion.noDataAvailable') }}
                </span>
            </div>
            <div class="dynamic-ess-promotion__close">
                <span class="sg-vrm-icon_055_cross-16px" @click="handleClosePromotion"></span>
            </div>
        </div>
        <div class="dynamic-ess-promotion__explanation">
            <div v-if="hasConfiguration">{{ $t('dynamicess.promotion.callToEnable') }}</div>
            <div v-else v-html="$t('dynamicess.promotion.explanation')"></div>
            <div v-html="$t('dynamicess.promotion.otherUsers')"></div>
        </div>
        <div class="dynamic-ess-promotion__action">
            <!-- <potential-earnings v-if="hasConfiguration" /> -->

            <button class="sg-btn sg-blue" @click="goToConfiguration">
                {{ $t('dynamicess.promotion.action') }}
            </button>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import PotentialEarnings from '@/vue/components/shared/dynamic-ess/PotentialEarnings.vue';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { PotentialEarnings },
})
@AngularDirective('dynamic-ess-promotion')
@AngularLocaleBundle('dynamicess')
export default class DynamicEssPromotion extends Vue {
    data() {
        return {
            hideDessConfiguration: false,
            sitePreferencesToAdd: {},
        };
    }
    @Prop({ type: Boolean, default: false })
    hasConfiguration;

    @ngInject()
    ApiService;

    @ngInject()
    $state;

    goToConfiguration() {
        this.$state.go('base.installation.settings.dynamicEss', { id: this.$route.params.id });
    }

    handleClosePromotion() {
        this.sitePreferencesToAdd = {
            hideConfigureDessOnDashboard: 1,
        };

        this.ApiService.updateSitePreferences(this.$route.params.id, this.sitePreferencesToAdd)
            .then(() => {
                this.hideDessConfiguration = true;
            })
            .catch(() => {
                this.hideDessConfiguration = true;
            });
    }

    created() {
        this.ApiService.getSitePreferences(this.$route.params.id)
            .then(response => {
                this.hideDessConfiguration = response.sitePreferences.hideConfigureDessOnDashboard;
            })
            .catch(() => {
                this.hideDessConfiguration = false;
            });
    }
}
</script>
